import * as types from './mutation-types'

// initial state
const state = {
    userId: null,
    firstName: null,
    lastName: null,
    username: null
};

// getters
const getters = {
    userId(state) {
        return state.userId;
    },
    firstName(state) {
        return state.firstName;
    },
    lastName(state) {
        return state.lastName;
    },
    username(state) {
        return state.username;
    },
    fullName(state, getters) {
        return `${getters.firstName} ${getters.lastName}`;
    }
};

// actions
const actions = {};

// mutations
const mutations = {
    [types.USER_ID](state, userId) {
        state.userId = userId;
    },
    [types.FIRST_NAME](state, firstName) {
        state.firstName = firstName;
    },
    [types.LAST_NAME](state, lastName) {
        state.lastName = lastName;
    },
    [types.USERNAME](state, username) {
        state.username = username;
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
    namespaced: true
};